<template>
  <div class="mt-4 remainder" :class="{ fixed: fixed }">
    <v-row class="ma-0">
      <v-col cols="6" class="pa-0 text-center">
        <v-icon>mdi-calendar-range-outline</v-icon>
        계획연차
        <div class="mt-1">
          <span class="point-blue data">{{ planCnt }}</span>
          <span class="cnt ml-1">개</span>
        </div>
      </v-col>
      <v-col cols="6" class="pa-0 text-center divider">
        <v-icon>mdi-list-box-outline</v-icon>
        잔여연차
        <div class="mt-1">
          <span class="point-blue data">{{ restCnt }}</span>
          <span class="cnt ml-1">개</span>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    planCnt: Number,
    restCnt: Number,
    fixed: Boolean,
  },
};
</script>

<style></style>
